import { render, staticRenderFns } from "./posMarge.vue?vue&type=template&id=1bd9de22&scoped=true&"
import script from "./posMarge.vue?vue&type=script&lang=js&"
export * from "./posMarge.vue?vue&type=script&lang=js&"
import style0 from "./posMarge.vue?vue&type=style&index=0&id=1bd9de22&prod&scoped=true&lang=css&"
import style1 from "./posMarge.vue?vue&type=style&index=1&id=1bd9de22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd9de22",
  null
  
)

export default component.exports